import { DISCOUNTS } from "../actionTypes";

export default function discountsReducer(state = null, action) {
  const { GET, ADD, UPDATE, RESET, TOGGLE } = DISCOUNTS;

  switch (action.type) {
    case GET:
      return action.payload;

    case ADD:
      const arr = state?.length ? state : [];
      return [...arr, action.payload];

    case UPDATE:
      return state.map((item) =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE:
      return state.map((item) =>
        item.id !== action.payload.id
          ? item
          : { ...item, enabled: !item.enabled }
      );

    case RESET:
      return null;

    default:
      return state;
  }
}
